export default {
  exam: {
    '请输入标签中文名称': 'الرجاء إدخال الاسم الصيني للملصق',
    '请输入标签西班牙名称': 'الرجاء إدخال الاسم الإسباني للملصق',
    '选项B为必填项': 'الخيار ب مطلوب',
    '暂无解析': 'لا يوجد قرار حتى الآن',
    '公告标题': 'عنوان الإعلان',
    '考试说明': 'وصف الاختبار',
    '确定要提交试卷吗': 'هل أنت متأكد أنك تريد تقديم هذا الاختبار',
    '分': 'نقاط',
    '当前限制选择 1 个文件': 'الحد الحالي هو تحديد ملف',
    '题型多选题': 'MCQ-المزيد',
    '题目配图': 'صورة الموضوع',
    '试卷类别': 'فئة الاختبار',
    '上一题': 'السؤال السابق',
    '视频名称(中文)': 'اسم الفيديو (الصينية)',
    '公告内容(法语)': 'محتوى الإعلان (فرنسي)',
    '请选择技能类别': 'الرجاء تحديد فئة المهارة',
    'ATG安装': 'تركيب ايه تي جي',
    '发布时间': 'وقت الإصدار',
    '已完成': 'مكتمل',
    '未读': 'غير مقروءة',
    '请开始作答': 'يرجى البدء في الإجابة',
    '获取试卷详情失败': 'فشل الحصول على تفاصيل الاختبار',
    '查询视频标签数据失败': 'فشل البحث في بيانات علامة الفيديو',
    '编辑题目': 'تحرير الموضوع',
    '退出考试，系统已自动提交试卷': 'عند الخروج من هذا الاختبار، يقوم النظام تلقائيًا بإرسال هذا الاختبار',
    '操作': 'عملية',
    '公告内容(西班牙)': 'محتوى الإعلان (بالإسبانية)',
    '题型介绍': 'مقدمة نوع السؤال',
    '证书类别': 'نوع الشهادة',
    '公告标题(法语)': 'عنوان الإعلان (فرنسي)',
    '答案解析': 'تحليل الإجابة',
    '多选题': 'MCQ-المزيد',
    '员工列表查询失败': 'فشل البحث في قائمة الموظفين',
    'LDS安装': 'تركيب LDS',
    '确定删除该题目吗': 'هل أنت متأكد أنك تريد حذف هذا الموضوع',
    '证书有效期': 'صلاحية الشهادة',
    '不合格': 'غير مؤهل',
    '视频封面(西班牙)': 'غلاف الفيديو (الإسبانية)',
    '题型分': 'نقاط',
    '视频类别': 'فئة الفيديو',
    '试卷总分': 'مجموع النقاط',
    '视频名称(英文)': 'اسم الفيديو (بالانجليزية)',
    '上传文件只能是mp4格式': 'لا يمكن تحميل الملفات إلا بتنسيق mp4',
    '合格': 'مؤهَل',
    '请输入标签英文名称': 'الرجاء إدخال الاسم الإنجليزي للملصق',
    '请输入公告内容(法语)': 'الرجاء إدخال محتوى الإعلان (باللغة الفرنسية)',
    '已读': 'قرأت',
    '序号': 'الرقم التسلسلي',
    '题目': 'عنوان',
    '视频封面(中文)': 'غلاف الفيديو (صيني)',
    '删除成功': 'تم الحذف بنجاح',
    '请输入标签法语名称': 'الرجاء إدخال الاسم الفرنسي للملصق',
    '删除': 'يمسح',
    '视频名称(西班牙)': 'اسم الفيديو (بالإسبانية)',
    '请输入公告内容(英文)': 'الرجاء إدخال محتوى الإعلان (باللغة الإنجليزية)',
    '分钟': 'دقائق',
    '道': 'أسئلة',
    '请输入视频名称(英文)': 'الرجاء إدخال اسم الفيديو (باللغة الإنجليزية)',
    '公告标题(西班牙)': 'عنوان الإعلان (بالإسبانية)',
    '请输入公告内容(西班牙)': 'الرجاء إدخال محتوى الإعلان(بالإسبانية)',
    '保存成功': 'حفظ بنجاح',
    '交卷时间已到，系统将帮您自动交卷': 'انتهى وقت تسليم الورقة، وسيقوم النظام تلقائيًا بتسليم الورقة لك',
    '添加题目': 'إضافة موضوع',
    '题目答案': 'إجابة الموضوع',
    '题目答案为必填项': 'مطلوب إجابة الموضوع',
    '视频文件(法语)': 'ملف فيديو (فرنسي)',
    '正确': 'صحيح',
    '确认编辑': 'تأكيد التحرير',
    '请输入公告标题(西班牙)': 'الرجاء إدخال عنوان الإعلان (بالإسبانية)',
    '全部题数': 'جميع الأسئلة',
    '题型每题': 'لكل سؤال',
    '视频文件(英文)': 'ملف الفيديو (الإنجليزية)',
    '资质证书': 'الشهادات',
    '及格标准': 'تمرير قياسي',
    '请选择题目类型': 'الرجاء تحديد نوع الموضوع',
    '提交试卷': 'إرسال ورقة الاختبار',
    '题型判断题': 'خطأ صحيح',
    '请上传视频文件(英文)': 'يرجى تحميل ملف فيديو (باللغة الإنجليزية)',
    '视频名称(法语)': 'اسم الفيديو (فرنسي)',
    '公告内容(中文)': 'محتوى الإعلان (صيني)',
    '员工': 'طاقم عمل',
    '系统将自动提交试卷，请确认是否离开考试': 'سيقوم النظام تلقائيًا بإرسال هذا الاختبار. يرجى التأكيد إذا كنت تريد ترك الاختبار',
    '视频文件(西班牙)': 'ملف الفيديو (الإسبانية)',
    '题型道': 'أسئلة',
    '参加考试': 'خذ الاختبار',
    '全部': 'الجميع',
    '题目内容': 'محتوى الموضوع',
    '考试开始时间': 'وقت بدء الاختبار',
    '单选题': 'MCQ-مفرد',
    '暂无': 'ليس بعد',
    '请输入公告标题(中文)': 'الرجاء إدخال عنوان الإعلان (بالصينية)',
    '考试结果': 'نتيجة الاختبار',
    '图片大小不能超过2MB': 'لا يمكن أن يتجاوز حجم الصورة 2 ميجابايت',
    '选项G': 'الخيار ز',
    '选项F': 'الخيار واو',
    '题型单选题': 'MCQ-مفرد',
    '选项E': 'الخيار ه',
    '选项D': 'الخيار د',
    '选项C为必填项': 'الخيار ج مطلوب',
    '返回': 'يعود',
    '选项C': 'الخيار ج',
    '请上传视频封面(英文)': 'يرجى تحميل غلاف الفيديو (باللغة الإنجليزية)',
    '选项B': 'الخيار ب',
    '选项A': 'الخيار أ',
    '题目内容为必填项': 'محتوى الموضوع مطلوب',
    '考试进行中': 'إمتحان يجري الأن',
    '确认添加': 'تأكيد الإضافة',
    '每题': 'لكل سؤال',
    '公告标题(英文)': 'عنوان الإعلان (باللغة الإنجليزية)',
    '视频封面': 'غلاف الفيديو',
    '视频名称': 'اسم الفيديو',
    '标签英文名称': 'تسمية الاسم باللغة الإنجليزية',
    'LDS安装技师考试': 'اختبار فني تركيب LDS',
    '开始考试': 'ابدأ الاختبار',
    '公告标题(中文)': 'عنوان الإعلان (بالصينية)',
    '标签法语名称': 'تسمية الاسم الاسباني',
    '选项A为必填项': 'الخيار أ مطلوب',
    '考试时长': 'مدة الاختبار',
    '加载中': 'تحميل',
    '试卷详情': 'تفاصيل الاختبار',
    '生成试卷失败': 'فشل في إنشاء ورقة الاختبار',
    '考试日期': 'تاريخ الاختبار',
    '视频封面(英文)': 'غلاف الفيديو (الإنجليزية)',
    '删除失败': 'فشل الحذف',
    '下一题': 'السؤال التالي',
    '自动计算成绩中': 'احتساب الدرجات تلقائيا',
    '题目类别': 'فئة الموضوع',
    '请输入公告内容(中文)': 'الرجاء إدخال محتوى الإعلان(بالصينية)',
    '点击下载': 'انقر فوق تنزيل',
    '再次考试': 'إعادة الاختبار',
    '组织员工': 'تنظيم الموظفين',
    '请选择视频类别': 'الرجاء تحديد فئة الفيديو',
    '视频封面(法语)': 'غلاف الفيديو (فرنسي)',
    '保存失败': 'فشل عملية الحفظ',
    '证书下载': 'تحميل الشهادة',
    '无': 'لا أحد',
    '请输入公告标题(法语)': 'الرجاء إدخال عنوان الإعلان (باللغة الفرنسية)',
    '错误': 'خطأ',
    '标签西班牙名称': 'تسمية الاسم الاسباني',
    '记录阅读状态失败': 'فشل تسجيل حالة القراءة',
    '交卷失败，数据库错误，请重新开始考试': 'فشل الإرسال، خطأ في قاعدة البيانات، يرجى إعادة تشغيل الاختبار',
    '标签中文名称': 'تسمية الاسم الصيني',
    '退出': 'يترك',
    '试卷类型': 'نوع الورق',
    '判断题': 'خطأ صحيح',
    '视频文件(中文)': 'ملف فيديو (صيني)',
    '视频文件': 'ملف فيديو',
    '提交成功': 'تم الإرسال بنجاح',
    '请输入公告标题(英文)': 'الرجاء إدخال عنوان الإعلان (باللغة الإنجليزية)',
    '确定开始考试吗': 'هل أنت متأكد أنك تريد بدء الاختبار',
    '技能类别': 'فئة المهارة',
    '上传头像图片只能是JPG/JPEG/PNG格式': 'فقط JPG/JPEG/PNG يمكن أن تكون صورة الملف الشخصي التي تم تحميلها بتنسيق',
    '下载失败': 'التحميل فشل',
    '可到记录页面查看成绩': 'انتقل إلى صفحة السجل لعرض النتائج',
    '公告内容': 'محتوى الإعلان',
    'ATG安装技师考试': 'اختبار فني تركيب ATG',
    '答题卡': 'ورقة الإجابة',
    '尚未完成所有题目，确定要提交试卷吗': 'لم تكمل جميع الأسئلة، هل أنت متأكد أنك تريد إرسال هذا الاختبار',
    '考试结束时间': 'وقت انتهاء الاختبار',
    '公告内容(英文)': 'محتوى الإعلان (باللغة الإنجليزية)'
  },
  route: {
    '功能管理': 'إدارة الوظائف',
    '视频标签管理': 'علامة الفيديو',
    '在线考试': 'اختبار عبر الإنترنت',
    '组织管理': 'إدارة المنظمة',
    '证书信息': 'معلومات الشهادة',
    '培训视频': 'فيديو التدريب',
    '考试培训': 'التدريب والاختبار',
    '题库管理': 'إدارة بنك الاختبار',
    '公告': 'إعلان',
    '设备关联': 'جمعية الجهاز',
    '用户管理': 'إدارةالمستخدم',
    '考试记录': 'سجلات الاختبار',
    '密码计算': 'حاسبة كلمة المرور',
    '证书统计': 'إحصائيات الشهادة',
    '单选题库管理': 'MCQ-مفرد',
    '多选题库管理': 'MCQ-المزيد',
    '经销商-设备关联': 'رابطة جهاز الموزع',
    '经销商-设备': 'رابطة جهاز الموزع',
    '培训视频管理': 'فيديو التدريب',
    '算号记录': 'سجلات الحساب',
    '判断题库管理': 'خطأ صحيح',
    '经销商-账号关联': 'رابطة حساب الموزع',
    '设备信息': 'معلومات الجهاز',
    '公告详情': 'تفاصيل الإعلان',
    '公告管理': 'إعلان',
    '系统字典': 'قاموس النظام',
    '系统管理': 'ادارة النظام',
    '经销商信息': 'معلومات الموزع',
    '角色管理': 'إدارة الأدوار',
    '技术文档资料库': 'مكتبة الوثائق التقنية',
    '员工权限': 'أذونات الموظفين',
    '账户管理': 'حساب'
  },
  file: {
    '1-1-3-1-1': '1-1-3-1-1 دليل PD-350+ مُشغِّل دبابة الشبكة V1-5-20250528.',
    '1-1-3-1-2': '1-1-3-1-2 الكتيبان 20250520 لمشغلي أجهزة التحكم في سلسلتي PD-350 و PD-350 +.',
    '1-1-3-1-4': '1-1-3-1-4 إم سي -6 وحدة التحكم المضادة للانفجار دليل V2.0.',
    '1-1-3-1-5': '1-1-3-1-5 دليل البدء السريع لوحدة التحكم (20250519)',
    '1-1-3-1-6': '1-1-3-1-6 توجيه إطلاق Ooket 20250522.',
    '1-1-3-1-7': '1-1-3-1-7 حسنا البدء السريع دليل',
    '1-1-4-2-1': '1-1-4-2-1 مقياس الخزان التلقائي لخزانات DEF دليل التركيب',
    '1-1-4-2-2': '1-1-4-2-2 دليل تركيب خزانات الغاز البترولي المسال',
    '1-1-4-2-3': '1-1-4-2-3 دليل تركيب ATG السلكي 20251125.',
    '1-1-4-2-4': '1-1-4-2-4 دليل تركيب مقياس الخزان التلقائي',
    '1-1-4-2-6': '1-1-4-2-6 توجيهات لتغيير طريقة تأريض مولد الطاقة التلقائي إلى طريقة تأريض طبقة الحماية من الخزان الواحد',
    '1-1-4-2-7': '1-1-4-2-7 دليل تركيب أداة قياس الخزان التلقائية لزيت التشحيم',
    '1-1-4-2-8': '1-1-4-2-8 دليل تثبيت ATG اللاسلكي 20250930.',
    '1-1-4-2-9': '1-1-4-2-9 عملية تركيب خلية الزر',
    '1-1-4-2-10': '1-1-4-2-10 تركيب مقياس مستوى الضغط التفاضلي ودليل التشغيل V1.1-20240829 EN',
    '1-1-4-3-1-1': '1-1-4-3-1-1 رسم حساب طول المسبار',
    '1-1-4-3-1-2': '1-1-4-3-1-2 جدول طول المسبار',
    '1-1-4-3-2-2': '1-1-4-3-2-2 المبادئ التوجيهية المتعلقة بتركيب الكابلات الكابلية في الموقع وتعديلها',
    '1-1-4-3-2-3': '1-1-4-3-2-3 دليل التعديل والتجديد اللاسلكي V1.0 20250415.',
    'B——3': "B——3'' B-type riser غطاء (خيط أنابيب معاهدة عدم الانتشار)-نموذج",
    'N——3': "N——3'' N-type riser غطاء (G أنبوب لولب)-طراز",
    'riser': 'قبر 2024.11.06.',
    '1-1-7-6-1': '1-1-7-6-1 دليل صيانة ناقل الحركة التلقائي',
    '1-1-7-6-2': '1-1-7-6-2 دليل حل المشكلات',
    '1-1-3-5-2': '1-1-3-5-2 عمليات التشغيل والصيانة اليومية (pdf)',
    '1-1-3-5-3': '1-1-3-5-3 إرشادات الاستخدام التلقائي لمقاييس الخزان',
    '1-1-9-1-1': '1-1-9-1-1 دليل استكشاف أخطاء وحدات التحكم في سلسلة PD-350 (20230807)',
    '1-2-4-1-1': '1-2-4-1-1 دليل تركيب مستشعر اكتشاف التسرب في وعاء الموزع DPLS-1 و DPLS-2C.',
    '1-2-4-1-2': '1-2-4-1-2 جهاز استشعار تسرب فجوة الخزان مزدوج الجدار دليل التركيب SFLS-2F.',
    '1-2-4-1-3': '1-2-4-1-3 دليل تركيب مستشعر اكتشاف التسرب في خط أنابيب الحائط المزدوج DLLS-2DA و DLLS-2C.',
    '1-2-4-1-4': '1-2-4-1-4 دليل تركيب مستشعر اكتشاف التسرب ثنائي الجدار الفولاذي FRP-SFLS-2DA SFLS-2C.',
    '1-2-4-1-5': '1-2-4-1-5 دليل تركيب مستشعر اكتشاف التسرب في الخزان ثنائي الجدار FRP HLS-1D',
    '1-2-4-1-6': '1-2-4-1-6 دليل تركيب جهاز استشعار اكتشاف التسرب في بئر فتحة التصريف CSLS-1',
    '1-2-4-1-7': '1-2-4-1-7 دليل تركيب مستشعر اكتشاف تسرب خزان الوقود الاحتوائي -FSLS-1',
    '1-2-4-1-9': '1-2-4-1-9 دليل تركيب مستشعر تسرب الهواء بالصهريج --vtls-1',
    '1-2-7-1': '1-2-7-1 Leak تعليمات تشغيل عنوان تعديل المستشعر',
    '1-1-4-4-1': '1-1-4-4-1 قائمة أدوات التثبيت لـ ATG و LDS.',
    '1-1-4-4-2': '1-1-4-4-2 نموذج قبول التركيب الخاص بمقاييس الخزانات الآلية',
    '1-1-5-1-1': '1-1-5-1-1 نظام (أوكيت) ATG يجب أن يكون واضحاً',
    '1-1-5-1-2': '1-1-5-1-2 يجب أن يكون أمر',
    '1-1-5-2-1': '1-1-5-2-1 إيه تي جي 2 بوصة قائمة التعبئة واستمارة القبول',
    '1-1-5-2-2': '1-1-5-2-2 قائمة التغليف (ATG 3 بوصة واستمارات الاستلام والفحص',
    '1-1-5-2-3': '1-1-5-2-3 ATG(اللاسلكية) قائمة التعبئة واستمارة القبول',
    '1-2-5-1-1': '1-2-5-1-1 قائمة التعبئة CSLS-1 ونماذج الاستلام والفحص',
    '1-2-5-1-2': '1-2-5-1-2 قائمة التعبئة واستمارة القبول',
    '1-2-5-1-3': '1-2-5-1-3 قائمة التعبئة DPLS-1 واستمارات الاستلام والفحص',
    '1-2-5-1-4': '1-2-5-1-4 قائمة التعبئة FSLS-1 واستمارات الاستلام والفحص',
    '1-2-5-2': '1-2-5-2 الكشف عن التركيب المتكامل نموذج القبول',
    '1-2-7-3-1': '1-2-7-3-1 دليل الصيانة LD',
    '1-2-7-3-2': '1-2-7-3-2 دليل استكشاف الأخطاء وإصلاحها LD',
    'HSSE要求': 'متطلبات الصحة والسلامة والبيئة',
    '1-1-4-1-2-2': 'تركيب المسبار 1-1-4-1-2-2 (2 بوصة، التمهيد)',
    '1-1-2-1-4': '1-1-2-1-4 MC-6 دليل مشغل وحدة التحكم المقاومة للانفجار V2.0',
    '1-1-4-1-2-1': '1-1-4-1-2-1 تركيب المسبار (2 بوصة، حلقة الاحتفاظ)',
    '1-1-2-1-3': '1-1-2-1-3 PD-350+ دليل التشغيل20190118',
    '1-1-2-1-2': '1-1-2-1-2 دليل مشغل وحدة التحكم من السلسلة PD-350 وPD-350+',
    '1-1-2-1-1': '1-1-2-1-1 PD-350+ دليل تشغيل الشبكة V1.0',
    'LD操作手册：请参考《ATG操作手册》LD改装及安装指南': 'LD دليل التحديث والتثبيت 《ATG دليل تشغيل》 يرجى الرجوع إلى:LD دليل تشغيل',
    '1-2-4-2-2': '1-2-4-2-2 كشف التسرب الهيدروستاتيكي للخزان مزدوج الجدار FRP',
    '1-2-4-2-1': '1-2-4-2-1 حساس كشف تسرب خط الأنابيب ذو الجدار المزدوج',
    '工具清单和收据模板': 'قائمة الأدوات ونموذج الاستلام',
    'LD改造和安装指南': 'دليل التحديث والتثبيت LD',
    'ATG操作手册': 'دليل تشغيل ATG',
    'ATG维护指南': 'دليل صيانة ATG',
    '1-1-5-1': '1-1-5-1 يجب أن يكون أمر ATG واضحًا',
    'ATG改造和安装指南': 'دليل التحديث والتثبيت ATG',
    'OKet HSSE管理体系要求V202306': 'متطلبات نظام إدارة OKet HSSE V202306',
    'LD系列文档': 'وثائق سلسلة LD',
    '1-1-2-4-1': '1-1-2-4-1 إعداد تعويض إمالة الخزان (pdf)',
    '1-1-4-1-1-1': '1-1-4-1-1-1 دليل تثبيت نظام ATG (3 بوصة)',
    '1-1-4-3-2-5': '1-1-4-3-2-5 رسم التجديد الجزئي للداخلية (pdf)',
    '1-1-4-3-2-4': '1-1-4-3-2-4 مخطط الأسلاك التحديثية (pdf)',
    '1-1-4-3-2-1': '1-1-4-3-2-1 مخطط تأريض إنشاءات ATG (pdf)',
    '1-2-5-3-2': '1-2-5-3-2 نموذج قبول وصول LD',
    '1-2-5-3-1': '1-2-5-3-1 ورقة قبول التثبيت والتصحيح LD',
    'ATG系列文档': 'وثائق سلسلة ATG',
    '1-1-4-4-3': '1-1-4-4-3 ورقة قبول تثبيت وتصحيح أخطاء ATG',
    'LD维护指南': 'دليل صيانة LD',
    '1-1-4-3-2-6': '1-1-4-3-2-6 كابل RVVP4-0.5'

  },
  lang: {
    '状态': 'حالة',
    '更改头像失败!': '!فشل في تغيير الصورة الرمزية',
    '未获取到经销商信息，请刷新页面': 'إذا لم تحصل على معلومات الموزع، يرجى تحديث الصفحة',
    '添加': 'يضيف',
    '请选择经销商': 'الرجاء تحديد الموزع',
    '该员工已添加': 'تمت إضافة فريق العمل',
    '添加组织': 'أضف منظمة',
    '请选择角色': 'الرجاء تحديد دور',
    '批量添加': 'استيراد دفعة',
    '请输入国家或地区': 'الرجاء إدخال البلد أو المنطقة',
    '添加成功': 'اضيف بنجاح',
    '设备识别码': 'رقم تعريف الجهاز',
    '用户名': 'اسم المستخدم',
    '地址': 'عنوان',
    '识别码已存在': 'رقم التعريف موجود بالفعل',
    '修改失败!': 'فشل في التعديل',
    '请输入姓名': 'الرجاء إدخال الاسم',
    '操作': 'عملية',
    '查询失败': 'فشل البحث',
    '当前版本': 'النسخة الحالية',
    '否': 'ن',
    '请选择': 'الرجاء التحديد',
    '是': 'ي',
    '绑定成功': 'تم الربط بنجاح',
    '审核失败': 'فشل في التدقيق',
    '没有更多了': 'لا يوجد أكثر',
    '登录': 'يدخل',
    '功能': 'وظيفة',
    '暂无数据': 'لا توجد بيانات في الوقت الراهن',
    '添加功能': 'إضافة وظيفة',
    '父级菜单': 'القائمة على مستوى الوالدين',
    '失效': 'الفعالية المفقودة',
    '维护': 'دليل صيانة أوكيت',
    '请输入加油站': 'من فضلك أدخل المحطة',
    '请选择审核结果': 'الرجاء تحديد نتائج التدقيق',
    '点击上传': 'انقر للتحميل',
    '文件': 'ملف',
    '参数键': 'مفتاح المعلمة',
    '操作人员': 'المشغل أو العامل',
    bullshit_info: 'يرجى التحقق مما إذا كان عنوان URL الذي أدخلته صحيحًا، يرجى النقر فوق الزر أدناه للعودة إلى الصفحة الرئيسية أو إرسال تقرير خطأ',
    '请选择员工': 'الرجاء اختيار الموظفين',
    '菜单查询': 'الاستعلام عن القائمة',
    '经销商名称': 'اسم الموزع',
    '关闭其它': 'إغلاق أخرى',
    '液位仪安装验收单': 'نموذج تأكيد فحص تصحيح الأخطاء OKet - مقياس الخزان التلقائي',
    '请输入菜单名': 'الرجاء إدخال اسم القائمة',
    '关闭所有': 'إغلاق الكل',
    '获取经销商信息失败': 'فشل الحصول على معلومات الموزع',
    cant_in: '...يقول مشرف الموقع أنه لا يمكنك الدخول إلى هذه الصفحة',
    '请输入': 'تفضل',
    '取消': 'يلغي',
    '类型': 'يكتب',
    '不同意': 'تعارض',
    '审核备注': 'ملاحظات التدقيق',
    '1个月密码': 'كلمة المرور لـ [مفتاح فعال لمدة شهر واحد]',
    '登录失败': 'فشل في تسجيل الدخول',
    '编辑菜单': 'تحرير القوائم',
    '员工': 'طاقم عمل',
    '同意': 'يوافق',
    '组织': 'منظمة',
    '请输入功能名称': 'الرجاء إدخال اسم الوظيفة',
    '禁用中': 'عاجز',
    '查询': 'يبحث',
    '姓名': 'اسم',
    '两次填写的密码不一致': 'كلمات المرور التي تم إدخالها مرتين غير متناسقة',
    '请输入设备识别码': 'الرجاء إدخال رقم تعريف الجهاز',
    '欢迎您使用澳科设备绑定功能': 'مرحبًا بك في وظيفة ربط جهاز OKet',
    '该角色将被删除, 是否继续?': 'سيتم حذف الدور، سواء الاستمرار؟',
    '名称已存在': 'الاسم موجود بالفعل',
    '修改密码': 'تغيير كلمة المرور',
    'TG密码': 'كلمة المرور لـ [الإعداد]',
    '功能url': 'عنوان URL للوظيفة',
    '确定space': 'يتأكد',
    '关联设备url': 'عنوان URL للجهاز المرتبط',
    '父级组织': 'منظمة على مستوى الوالدين',
    '图片大小超过1M，请重新选择!': '1M حجم الصورة أكبر من ، يرجى تحديدها مرة أخرى',
    '复制成功': 'الاستنساخ الناجح',
    '加油站': 'محطة',
    '液位仪密码': 'كلمة المرور لـ [مقياس مستوى السائل]',
    '请选择设备识别码': 'الرجاء تحديد رقم تعريف الجهاز',
    '请上传正确的图片格式（jpge/jpg/png/gif）': 'يرجى تحميل الصورة بالتنسيق الصحيح (jpge/jpg/png/gif)',
    '确认密码': 'تأكيد كلمة المرور',
    '您已修改状态为 --> 禁用': 'لقد قمت بتعديل الحالة إلى --> معطل',
    '编辑角色': 'تحرير الدور',
    '绑定密码': 'ربط كلمة المرور',
    '两次输入密码不一致': 'كلمات المرور التي تم إدخالها مرتين غير متناسقة',
    '审核意见': 'آراء التدقيق',
    '只能上传xlsx/xls文件，且不超过500kb': 'فقط، ولا يمكن أن يتجاوز حجمها 500 كيلو بايت xlsx/xls يمكن تحميل ملفات',
    '请输入不少于4位的用户名': 'الرجاء إدخال اسم مستخدم لا يقل عن 4 أرقام',
    '参数键已存在': 'مفتاح المعلمة موجود بالفعل',
    '经销商': 'موزع',
    '设置列': 'تعيين العمود',
    '请输入功能': 'الرجاء إدخال وصف الوظيفة',
    '审核': 'مراجعة',
    '审核成功': 'تم التدقيق بنجاح',
    '无此密码类型': 'لا يوجد نوع كلمة المرور هذا',
    '请选择可计算密码类型': 'الرجاء تحديد أنواع كلمة المرور',
    '该用户名已存在': 'اسم المستخدم هذا موجود بالفعل',
    '请输入流水号': 'الرجاء إدخال الرقم التسلسلي',
    '复制': 'ينسخ',
    '上滑查看更多': 'اسحب للأعلى لرؤية المزيد',
    '自定义期限密码': 'كلمة المرور لـ [المدة المخصصة]',
    '无权限': ' 无权限',
    '功能名': 'اسم وظيفة',
    '作废': 'يلغي',
    '备注': 'ملاحظات',
    '认证经销商服务平台': 'منصة دعم المقاولين المعتمدين',
    '用户密码为': ' 用户密码为',
    '确认作废此数据?': 'هل تؤكد أن هذه البيانات غير صالحة؟',
    '关闭': 'يغلق',
    '邮箱': 'عنوان البريد الإلكتروني',
    '启用': 'يُمكَِن',
    '设备关联': 'جمعية الجهاز',
    '该经销商未关联用户': 'هذا الموزع ليس لديه مستخدمين مرتبطين',
    '请输入流水号/注册编号': 'الرجاء إدخال الرقم التسلسلي/التسجيل',
    '更改头像成功!': 'تم تغيير الصورة الرمزية بنجاح',
    '修改时间': 'وقت التعديل',
    '下载': 'تحميل',
    '序号必须为正数': 'يجب أن يكون الرقم التسلسلي موجبًا',
    '添加角色': 'أضف دور',
    '确定': 'يتأكد',
    '流水号': 'رقم سري',
    '编辑成功': 'تم التعديل بنجاح',
    '绑定': 'ربط',
    '菜单': 'القوائم',
    '青岛澳科仪器有限责任公司': 'تشينغداو أوكيت صك المحدودة',
    '密码': 'كلمة المرور',
    '角色': 'دور',
    '最近修改时间': 'آخر وقت للتعديل',
    '确认': 'يتأكد',
    '添加菜单': 'إضافة القائمة',
    '退出登录': 'تسجيل خروج',
    '该组织名称已存在': 'اسم المنظمة موجود بالفعل',
    '当前限制选择 1 个文件': 'الحد الحالي هو تحديد ملف',
    '地址错误，请检查': 'العنوان خاطئ، يرجى التحقق',
    '请选择型号': 'الرجاء اختيار النموذج',
    '作废成功': 'تم إبطاله بنجاح',
    '请输入审核意见': 'الرجاء إدخال آراء التدقيق',
    '编辑组织': 'تحرير المنظمة',
    '保存': 'يحفظ',
    '批量添加失败': 'فشلت الإضافة على دفعات',
    '请输入功能url': 'الرجاء إدخال عنوان URL للوظيفة',
    '客服销售人员': 'مندوب مبيعات خدمة العملاء',
    '澳科设备认证平台': 'منصة اعتماد الأجهزة OKet',
    '经销商账号关联': 'جمعية حساب الموزع',
    '探棒设置密码': 'كلمة المرور لـ [إعداد المسبار]',
    '将文件拖到此处，或': 'اسحب الملف هنا، أو',
    '请输入识别码': 'الرجاء إدخال رقم الهوية',
    '菜单/功能': 'القوائم/الوظيفة',
    '2个月密码': 'كلمة المرور لـ [مفتاح فعال لمدة شهرين]',
    '审核结果': 'نتائج التدقيق',
    '新密码': 'كلمة المرور الجديدة',
    '获取url失败': 'فشل الحصول على عنوان URL',
    '重置失败': 'فشلت إعادة التعيين',
    '流水号/注册编号': 'الرقم التسلسلي/التسجيل',
    '状态修改失败': 'فشل تعديل الحالة',
    '经销商设备关联': 'جمعية جهاز الموزع',
    '级参数': '#NAME?',
    '编辑': 'يحرر',
    '修改成功,请重新登录!': 'تم التعديل بنجاح، يرجى تسجيل الدخول مرة أخرى',
    '所属组织': 'المنظمة التابعة',
    '经销商信息': 'معلومات الموزع',
    '启用中': 'ممكّن',
    '是否必选': 'مطلوب أم لا',
    '所有语言参数值 都不能为空': 'لا يمكن أن تكون كافة قيم معلمات اللغة فارغة',
    '序号': 'الرقم التسلسلي',
    '电话': 'هاتف',
    '参数值': 'قيمة المعلمة',
    '永久期限密码': 'كلمة المرور لـ [المفتاح الدائم]',
    '请选择账号': 'الرجاء تحديد الحساب',
    '编辑功能': 'تحرير الوظائف',
    '有效': 'فعال',
    '取消space': 'يلغي',
    '原始密码': 'كلمة المرور الأصلية',
    '国家或地区': 'الدولة او المنطقة',
    '获取组织根节点列表失败': 'فشل الحصول على قائمة العقد الجذرية للمؤسسة',
    '请先选择类型': 'حدد النوع أولا',
    '可选择': 'خياري',
    '编辑失败': 'فشل التعديل',
    '编辑用户': 'تحرير العضو',
    '提示': 'إشعار',
    '识别码': 'رقم الهوية',
    '请输入参数键': 'الرجاء إدخال مفتاح المعلمة',
    '用户名中不能有空格': 'يجب ألا تكون هناك مسافات في اسم المستخدم',
    '此操作将重置': '此操作将重置 ',
    '模板': 'نموذج',
    '请选择头像上传': 'الرجاء تحديد الصورة الرمزية للتحميل',
    '导出': 'يصدّر',
    '未登录': 'لم تقم بتسجيل الدخول',
    '请输入原始密码': 'الرجاء إدخال كلمة المرور الأصلية',
    '请输入名称': 'الرجاء إدخال الاسم',
    '序号不能为空': 'لا يمكن أن يكون الرقم التسلسلي فارغًا',
    '当前账号未绑定经销商，请联系管理员绑定': 'الحساب الجاري غير مرتبط بالموزع، يرجى الاتصال بالمسؤول لربطه',
    '测漏安装验收单': 'نموذج تأكيد فحص تصحيح الأخطاء OKet - نظام كشف التسرب',
    '请输入新密码': 'الرجاء إدخال كلمة المرور الجديدة',
    '您已修改状态为 --> 启用': 'لقد قمت بتعديل الحالة إلى --> ممكّن',
    '账号': 'حساب',
    '已取消重置': 'تم إلغاء إعادة التعيين',
    '请输入组织名称': 'الرجاء إدخال اسم المنظمة',
    '联系人': 'جهات الاتصال',
    '请输入不少于6位的密码': 'الرجاء إدخال كلمة مرور لا تقل عن 6 أرقام',
    '版权所有': 'كل الحقوق محفوظة',
    '设备信息批量导入模板': 'قالب استيراد دفعة معلومات الجهاز',
    '名称': 'اسم',
    '对应设备已存在': 'الجهاز المقابل موجود بالفعل',
    '请输入角色名称': 'الرجاء إدخال اسم الدور',
    '图片命名中包含特殊字符，请规正命名再上传!': 'تحتوي الصورة على أحرف خاصة، يرجى إعادة تسميتها وتحميلها مرة أخرى',
    '输入用户名': 'الرجاء إدخال اسم المستخدم',
    '请选择文件': 'الرجاء تحديد الملف',
    '作废失败': 'فشل في إبطاله',
    '请先选择经销商': 'حدد الموزع أولاً',
    '批量添加成功': 'تمت إضافة الدفعة بنجاح',
    '添加用户': 'إضافة مستخدم',
    '添加失败': 'فشلت الإضافة',
    '算号记录': 'سجلات الحساب',
    '重置成功': 'تمت إعادة الضبط بنجاح',
    '请选择组织': 'الرجاء تحديد منظمة',
    ', 是否继续?': '، سواء الاستمرار؟',
    '暂未登录或token已经过期': 'لم يتم تسجيل الدخول أو انتهت صلاحية الرمز المميز',
    '3个月密码': 'كلمة المرور لـ [مفتاح فعال لمدة 3 أشهر]',
    '设备信息': 'معلومات الجهاز',
    '管理员': 'مدير',
    '编号': 'رقم',
    '请选择类型': 'الرجاء تحديد النوع',
    '绑定失败': 'فشل في الربط',
    '经销商编号': 'رقم الموزع',
    '服务器未启动/响应错误': 'الخادم لا يبدأ/خطأ في الاستجابة',
    '修改头像': 'تعديل الصورة الرمزية',
    '请输入用户名': 'الرجاء إدخال اسم المستخدم',
    '请输入菜单': 'الرجاء إدخال القوائم',
    '型号': 'نموذج',
    advice: 'لكي نقدم لك تجربة مستخدم أفضل، نوصي بشدة باستخدام وضع السرعة أو متصفح Chrome',
    '禁用': 'إبطال',
    '重置密码': 'إعادة تعيين كلمة المرور',
    '菜单名': 'اسم القائمة',
    '最近登录时间': 'آخر وقت لتسجيل الدخول',
    '可计算密码类型': 'أنواع كلمة المرور',
    '数据加载中': 'جارٍ تحميل البيانات',
    '请确认密码': 'الرجاء تأكيد كلمة المرور',
    '确认新密码': 'تأكيد كلمة المرور الجديدة',
    '请选择功能': 'الرجاء تحديد الوظيفة',
    '请输入正确的邮箱地址': 'يرجى إدخال عنوان البريد الإلكتروني الصحيح',
    return_home: 'العودة إلى المركز الشخصي',
    '安装工具清单': 'قائمة أدوات تثبيت OKet',
    '请输入密码': 'من فضلك أدخل رقمك السري',
    '创建时间': 'وقت الإنشاء',
    '您的密码强度太低，请尽快修改密码': 'مستوى أمان كلمة المرور الخاصة بك منخفض جدًا، يرجى تغييره في أقرب وقت ممكن',
    '操作维护指南': 'OKet التشغيل والصيانة اليومية',
    '计算失败': 'فشل الحساب'
  },
  fun: {
    'App': 'برنامج',
    '用户权限': 'حقوق المستخدم',
    '公告（详情）': 'إعلان (التفاصيل)',
    '角色查询所有得权限': 'البحث عن الأدوار في جميع الأذونات',
    '员工权限查询设备经销商全部': 'إذن الموظف تجار معدات البحث جميعا',
    '经销商-设备关联更新经销商设备关联信息': 'يقوم اقتران جهاز البائع بتحديث معلومات اقتران جهاز البائع',
    '添加组织': 'أضف منظمة',
    '证书分页': 'ترقيم الصفحات الشهادة',
    '获取所有的菜单': 'الحصول على كافة القوائم',
    '题库管理': 'إدارة بنك الاختبار',
    '分页查询算号': 'ترقيم البحث في الصفحات',
    '培训视频分页（管理）': 'ترقيم صفحات الفيديوهات التدريبية (الإدارة)',
    '编辑组织': 'تحرير المنظمة',
    '经销商信息作废': 'معلومات الموزع غير صالحة',
    '查询当前用户角色': 'ابحث في دور المستخدم الحالي',
    '用户管理': 'إدارةالمستخدم',
    '获取关联设备的url': 'احصل على عنوان URL للجهاز المرتبط',
    '校验组织是否存在': 'التحقق من وجود المنظمة',
    '考试记录': 'سجلات الاختبار',
    '用户密码修改': 'تغيير كلمة مرور المستخدم',
    '添加培训视频': 'إضافة فيديو تدريبي',
    '分页查询经销商设备关联': 'ابحث عن جمعية معدات التاجر حسب الصفحة',
    '添加公告': 'إضافة إعلان',
    '证书下载（考试记录）': 'تنزيل الشهادة (سجل الاختبار)',
    '设备识别码判重': 'حكم رمز تعريف الجهاز',
    '编辑培训视频': 'تحرير فيديو التدريب',
    '判断题库管理': 'خطأ صحيح',
    '编辑培训视频标签': 'تحرير علامات فيديو التدريب',
    '删除题目（多选）': 'حذف الموضوع (MCQ-المزيد)',
    '员工权限获取所有得用户列表': 'إذن الموظف للحصول على كافة قوائم المستخدمين',
    '新增试卷': 'ورقة اختبار جديدة',
    '培训视频标签分页（视频）': 'ترقيم الصفحات لمقاطع الفيديو التدريبية (مقاطع الفيديو)',
    '公告详情': 'تفاصيل الإعلان',
    '公告管理': 'إعلان',
    '题目列表分页(单选)': 'ترقيم الصفحات لقائمة المواضيع (MCQ-Single)',
    '更新设备信息': 'تحديث معلومات الجهاز',
    '员工权限获取当前用户的经销商': 'أذونات الموظف احصل على موزعي المستخدم الحالي',
    '删除公告': 'إعلان حذف',
    '分页查询员工权限': 'البحث في أذونات الموظف حسب الصفحة',
    '编辑公告': 'تحرير إعلان',
    '获取当前用户的经销商': 'احصل على موزع المستخدم الحالي',
    '查询指定用户组织下的用户': 'ابحث عن المستخدمين ضمن مؤسسة المستخدم المحددة',
    '经销商信息': 'معلومات الموزع',
    '员工权限查询经销商账号关联全部': 'حساب تاجر إذن الموظف المرتبط بالجميع',
    '分页查询经销商账号关联': 'البحث عن ارتباط حساب التاجر حسب الصفحة',
    '添加设备信息': 'إضافة معلومات الجهاز',
    '用户列表': 'قائمة المستخدم',
    '阅读公告': 'إقرأ إعلان',
    '添加培训视频标签': 'إضافة علامة فيديو التدريب',
    '新增题目（多选）': 'إضافة موضوع (MCQ-المزيد)',
    '培训视频标签分页': 'ترقيم صفحات علامة تبويب مقاطع الفيديو التدريبية',
    '培训视频': 'فيديو التدريب',
    '校验参数键是否重复': 'التحقق من مفاتيح المعلمات المكررة',
    '试卷内容': 'محتوى ورقة الاختبار',
    '公告分页': 'صفحة الإعلان',
    '分页查询设备': 'جهاز بحث الصفحات',
    '查询算号记录算密码类型': 'بحث رقم حساب سجل حساب كلمة المرور نوع',
    '查询员工权限算密码类型': 'بحث سلطة الموظف وحساب نوع كلمة المرور',
    '设备作废': 'المعدات عفا عليها الزمن',
    '经销商-设备关联查询经销商设备关联全部': 'جمعية تاجر المعدات بحث جمعية تاجر المعدات الكل',
    '添加系统字典': 'إضافة قاموس النظام',
    '公告': 'إعلان',
    '添加/编辑权限': 'إضافة/تحرير الأذونات',
    '获取算号': 'احصل على العد',
    '多选题库管理': 'MCQ-المزيد',
    '经销商账号关联作废': 'اقتران حساب الموزع باطل',
    '查询设备全部': 'البحث في جميع الأجهزة',
    '员工权限作废': 'سلطة الموظف باطلة',
    '获取全部国家和地区': 'الحصول على جميع البلدان والمناطق',
    '更新经销商设备关联信息': 'تحديث معلومات جمعية معدات الوكيل',
    '查询经销商设备关联全部': 'بحث جمعية معدات تاجر الكل',
    '添加经销商账号关联信息': 'أضف المعلومات المرتبطة بحساب التاجر',
    '系统管理': 'ادارة النظام',
    '经销商-账号关联查询设备经销商全部': 'تاجر-الحساب المرتبط بتجار معدات البحث الكل',
    '用户是否存在': 'هل المستخدم موجود',
    '培训视频分页': 'صفحات الفيديو التدريبية',
    '员工权限': 'أذونات الموظفين',
    '查询所有得权限': 'تحقق من كافة الأذونات',
    '提交试卷': 'إرسال ورقة الاختبار',
    '在线考试': 'اختبار عبر الإنترنت',
    '添加经销商信息': 'إضافة معلومات التاجر',
    '证书信息': 'معلومات الشهادة',
    '经销商-设备关联经销商设备关联作废': 'اقتران معدات التاجر اقتران معدات التاجر غير صالح',
    '获取所有得用户列表': 'الحصول على قائمة بجميع المستخدمين',
    '更新设备信息admin': 'تحديث معلومات الجهاز المشرف',
    '查询全部算号': 'بحث في جميع الأرقام',
    '技术文档资料库界面': 'واجهة مكتبة المستندات الفنية',
    '查询系统字典类型': 'نوع قاموس نظام البحث',
    '删除题目（单选）': 'حذف الموضوع (MCQ-فردي)',
    '用户列表（统计）': 'قائمة المستخدمين (الإحصائيات)',
    '查询角色列表': 'ابحث عن قائمة الأدوار',
    '编辑员工权限': 'تحرير أذونات الموظف',
    '证书分页（统计）': 'ترقيم الصفحات في الشهادة (الإحصائيات)',
    '添加员工权限': 'إضافة أذونات الموظف',
    '证书统计': 'إحصائيات الشهادة',
    '查询下一级系统字典项': 'ابحث في المستوى التالي من إدخالات قاموس النظام',
    '经销商-设备关联查询设备全部': 'معدات البحث عن جمعية تاجر المعدات جميعها',
    '培训视频管理': 'فيديو التدريب',
    '算号记录': 'سجلات الحساب',
    '经销商-设备关联分页查询经销商设备关联': 'صفحة اقتران جهاز الموزع، ابحث عن جمعية جهاز الموزع',
    '新增试卷（考试）': 'ورقة اختبار جديدة (اختبار)',
    'getInfo': 'يحصل على معلومات',
    '设备查询下一级系统字典项': 'البحث في الجهاز عن عنصر قاموس نظام المستوى التالي',
    '组织根节点列表': 'قائمة العقد الجذرية التنظيمية',
    '题目列表分页（多选）': 'ترقيم الصفحات لقائمة المواضيع (MCQ-المزيد)',
    '设备信息': 'معلومات الجهاز',
    '公告分页（管理）': 'علامة تبويب الإعلانات (الإدارة)',
    '更新设备信息noadmin': 'تحديث معلومات الجهاز noAdmin',
    '校验经销商员工关系是否唯一': 'تأكد من أن العلاقة بين الوكيل والموظف فريدة من نوعها',
    '用户头像-上传本地': 'الصورة الرمزية للمستخدم - تحميل محلي',
    '员工权限查询经销商设备关联全部': 'إذن الموظف البحث عن جمعية معدات تاجر الكل',
    '分页查询系统字典项(树形)': 'عناصر قاموس نظام بحث الترحيل (شجرة)',
    '技术文档资料库': 'مكتبة الوثائق التقنية',
    '查询设备经销商全部': 'بحث عن تجار المعدات',
    '删除角色': 'حذف الدور',
    '功能管理': 'إدارة الوظائف',
    '视频标签管理': 'علامة الفيديو',
    '组织管理': 'إدارة المنظمة',
    '更新经销商账号关联信息': 'تحديث المعلومات المرتبطة بحساب التاجر',
    '新增题目（判断）': 'إضافة موضوع جديد (الحكم)',
    '经销商名称、编号判重': 'اسم الموزع والرقم التسلسلي',
    '经销商-设备关联查询设备经销商全部': 'جمعية تجار المعدات تبحث عن جميع تجار المعدات',
    '查询所有系统字典项-列表': 'ابحث في جميع عناصر قاموس النظام - القائمة',
    '经销商-账号关联获取所有得用户列表': 'اقتران حساب التاجر للحصول على قائمة بجميع المستخدمين',
    '经销商-设备关联添加经销商设备关联信息': 'اقتران جهاز البائع أضف معلومات اقتران جهاز البائع',
    '添加/编辑角色': 'إضافة/تحرير الأدوار',
    '考试培训': 'التدريب والاختبار',
    '新增题目（单选）': 'إضافة موضوع (MCQ-فردي)',
    '分页查询组织': 'منظمة البحث المصفح',
    '设备关联': 'جمعية الجهاز',
    '更新经销商信息': 'تحديث معلومات التاجر',
    '编辑系统字典': 'تحرير قاموس النظام',
    '试卷分页（考试记录）': 'ترقيم صفحات أوراق الاختبار (سجلات الاختبار)',
    '经销商设备关联审核': 'مراجعة جمعية المعدات الموزعة',
    '单选题库管理': 'MCQ-مفرد',
    '密码计算': 'حاسبة كلمة المرور',
    '培训视频标签分页（管理）': 'ترقيم الصفحات لمقاطع الفيديو التدريبية (الإدارة)',
    '经销商-设备关联': 'رابطة جهاز الموزع',
    '用户密码重置': 'إعادة تعيين كلمة مرور المستخدم',
    '删除培训视频标签': 'إزالة علامات الفيديو التدريبي',
    '添加经销商设备关联信息': 'أضف معلومات جمعية معدات الوكيل',
    '证书下载': 'تحميل الشهادة',
    '查询经销商账号关联全部': 'بحث جمعية حساب تاجر الكل',
    '经销商-账号关联': 'رابطة حساب الموزع',
    '用户列表（证书）': 'قائمة المستخدمين (الشهادة)',
    '经销商设备关联作废': 'اقتران معدات البائع غير صالح',
    '查询员工权限全部': 'البحث في جميع أذونات الموظف',
    '批量导入设备信息': 'دفعة معلومات الجهاز الاستيراد',
    '题目列表分页（判断）': 'ترقيم الصفحات لقائمة المواضيع (الحكم)',
    '系统字典': 'قاموس النظام',
    '分页查询经销商': 'البحث عن التجار حسب الصفحة',
    '添加/修改用户': 'إضافة/تعديل المستخدمين',
    '用户管理查询当前用户角色': 'إدارة المستخدم بحث دور المستخدم الحالي',
    '删除题目（判断）': 'حذف الموضوع (الحكم)',
    '证书下载（统计）': 'تنزيل الشهادة (الإحصائيات)',
    '角色管理': 'إدارة الأدوار',
    '右上角添加/修改用户': 'إضافة/تعديل المستخدمين في الزاوية اليمنى العليا',
    '删除培训视频': 'حذف فيديو التدريب',
    '查询当前用户组织下可查看角色': 'ابحث في الأدوار المتاحة ضمن مؤسسة المستخدم الحالية',
    '查询密码计算算密码类型': 'بحث حساب كلمة المرور حساب نوع كلمة المرور'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js